var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraditionalBanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.635,
    height: 111.68,
    viewBox: "0 0 117.635 111.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6e7e9d",
    d: "M82.033 43.486h23.087M82.033 86.655h23.087m-6.267-43.169v43.169m-5.276-43.169v43.169m-5.275-43.169v43.169M47.274 43.486h23.087M47.274 86.655h23.087m-6.268-43.169v43.169m-5.275-43.169v43.169m-5.276-43.169v43.169M12.514 43.486h23.087M12.514 86.655h23.087m-6.268-43.169v43.169m-5.275-43.169v43.169m-5.276-43.169v43.169"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M12.514 31.474h92.606v6.006H12.514zM8.265 92.661h101.104v6.006H8.265zm-3.262 6.006h107.63v6.006H5.003zm-2.741 6.007h113.111v6.006H2.262zM58.817 1.107L1 28.471v3h115.635v-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditionalBanks);
export default __webpack_public_path__ + "static/media/traditionalBanks.c57e85c9b66b4cd163c512ff57ccc8d7.svg";
export { ForwardRef as ReactComponent };